import React from 'react';
import styled from 'styled-components';

import colors from '../../libs/colors';
import images from '../../assets';

export const DesignMenu = styled.div`
  position: absolute;
  background-color: white;
  left: 0px;
  top: 100[x];
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 27px;
  padding-bottom: 30px;
`;

export const DesignGroupBlock = styled.div`
  width: 170px;
  padding-top: 20px;
  padding-bottom: 20px;
  z-index: 99;
`;

const GroupActbtn = styled.div`
  /* font-family: "NSCJKrB"; */
  font-family: 'NSCJKrR';
  color: #fe8b07;
  font-size: 18px;
  line-height: 48px;
  padding-left: 26px;
  cursor: pointer;
  border-bottom-style: solid;
  border-bottom-color: #fe8b07;
  border-bottom-width: 1px;
  border-left-style: solid;
  border-left-color: #fe8b07;
  border-left-width: 1px;
  border-top-style: solid;
  border-top-color: #fe8b07;
  border-top-width: 1px;
  z-index: 999;
  border-right-style: solid;
  border-right-color: white;
  border-right-width: 2px;
  background-color: white;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  display: flex;
`;

const GroupNorbtn = styled.div`
  font-family: 'NSCJKrR';
  color: black;
  z-index: 999;
  font-size: 18px;
  line-height: 48px;
  padding-left: 26px;
  cursor: pointer;
`;

export const DesignGroupBtn = ({ title, active = false, ...props }) => {
  return active ? (
    <GroupActbtn {...props}>
      <div style={{ flex: 1 }}>{title}</div>
      <div style={{ paddingRight: 7 }}>
        <img alt="" src={images.topmenu_sub} />
      </div>
    </GroupActbtn>
  ) : (
    <GroupNorbtn {...props}>
      <div style={{ flex: 1 }}>{title}</div>
    </GroupNorbtn>
  );
};

export const DesignDetailBlock = styled.div`
  width: 1000px;
  margin-left: -1px;
  z-index: 0;
  border-width: 1px;
  border-color: #fe8b07;
  border-style: solid;
  border-radius: 5px;
  padding: 20px;
  display: flex;
`;

export const DesignDetailColumn = styled.div`
  width: 227px;
`;

export const DesignDetailBtn = ({ title, active = false, ...props }) => {
  return (
    <div style={active ? subActbtn : subNorbtn} {...props}>
      {title}
    </div>
  );
};

const subNorbtn = {
  fontFamily: 'NSCJKrR',
  color: 'black',
  cursor: 'pointer',
  fontSize: 18,
  lineHeight: '48px',
  paddingLeft: 39,
  zIndex: 99,
};

const subActbtn = {
  // fontFamily: "NSCJKrB",
  fontFamily: 'NSCJKrR',
  color: colors.active,
  cursor: 'pointer',
  fontSize: 18,
  lineHeight: '48px',
  paddingLeft: 39,
  zIndex: 99,
};
